import { initializeIcons } from '@office-start/fabric-icon-subset-utility';
import { initializeFileTypeIcons } from '@uifabric/file-type-icons';
import { CapabilitiesService } from '../shared-context/capabilities.service';
import { ClientStartupConfigService } from '../shared-context/client-startup-config.service';
import { ContextService } from '../shared-context/context.service';

// TODO: Move to office-start components since fonts are defined and used there
export function initializeFluentIcons(capabilitiesService: CapabilitiesService, contextService: ContextService, startupConfigService: ClientStartupConfigService) {
    initializeIcons(false, capabilitiesService.capabilities.fluentIconFontEnabled, contextService.sharedContext.inMockMode ? undefined : startupConfigService.config.officeStartCdnDomain);
    initializeFileTypeIcons();
}
